import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";


const ResetPasswordFormData = {
  name: "ResetPassword",
  initialState: { temporaryPassword: "", password: "", userId: "" },
  section: [
    {
      sectionId: "ResetPassword",
      title: "Reset Password",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
    {
      id: "TemporaryPassword",
      label: "Temporary Password",
      Field_Name: "temporary password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "temporaryPassword",
      fieldSetting: {
        placeholder: "Paste the temporary password from your latest reset email",
      },
      style: {
        containerCss: "col-md-12 mb-2 validation-left-0",
      },
      validation: [{ type: validationTypes.REQUIRE }],
    },
    {
      id: "Password",
      label: "New Password",
      Field_Name: "new password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "password",
      fieldSetting: {
        placeholder: "Please Enter New Password",
      },
      style: {
        containerCss: "col-md-12 mb-2 validation-left-0",
      },
      validation: [{ type: validationTypes.REQUIRE }, { type: validationTypes.PASSWORD }],
    },
    {
      id: "ConfirmPassword",
      label: "Confirm Password",
      Field_Name: "confirm new password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "Confirmpassword",
      fieldSetting: {
        placeholder: "Please Re-enter New Password",
      },
      style: {
        containerCss: "col-md-12 mb-2 validation-left-0",
      },
      validation: [{ type: validationTypes.REQUIRE }, { type: validationTypes.PASSWORD }],
    },
      ]
    }
  ]
}

export default ResetPasswordFormData;
